import script from "./IoSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./IoSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./IoSidebar.vue?vue&type=style&index=0&id=3bdca822&lang=scss"

const __exports__ = script;

export default __exports__